import { createSelector } from 'reselect'

import { selectCurrentTicket } from 'selectors/tickets'

export default createSelector(selectCurrentTicket, ticket => {
  return ticket && ticket.linkedExternalResources
})
